/**
 * Domain configuration helper to manage environment-specific domains
 */

// Base domains
const PROD_DOMAIN = 'indiansfrontoffice.com';
const GCP_DOMAIN = 'guardiansfrontoffice.com';

// Environment detection
const isProd = () => window.location.hostname === `dv.${PROD_DOMAIN}`;
const isBeta = () => window.location.hostname === `beta.${PROD_DOMAIN}`;
const isLocal = () => window.location.hostname === 'localhost';

// Domain getters
export const getDvDomain = () => {
  if (isLocal()) return 'http://localhost:5173';
  if (isBeta()) return `https://dv.dev.bb.gcp.${GCP_DOMAIN}`;
  return `https://dv.bb.${GCP_DOMAIN}`;
};

export const getNodeDomain = () => {
  if (isLocal()) return 'http://localhost:3030';
  if (isBeta()) return `https://nsvc-dev.${PROD_DOMAIN}`;
  return `https://nsvc.${PROD_DOMAIN}`;
};

export const getBiDomain = () => {
  return `https://bi.${PROD_DOMAIN}`;
};

export const getMainDomain = () => {
  if (isLocal()) return 'localhost';
  if (isBeta()) return `beta.${PROD_DOMAIN}`;
  return `dv.${PROD_DOMAIN}`;
};

export const getEnvironment = () => {
  if (isLocal()) return 'local';
  if (isBeta()) return 'beta';
  return 'production';
};

// Helper functions
export const getNodeServiceUrl = (service = '') => {
  const base = getNodeDomain();
  return service ? `${base}/${service}` : base;
};

export const getDvServiceUrl = (path = '') => {
  const base = getDvDomain();
  return path ? `${base}/${path}` : base;
};

export const getBiServiceUrl = (path = '') => {
  const base = getBiDomain();
  return path ? `${base}/${path}` : base;
}; 